import { css, type Theme } from '@emotion/react';

export const container = css`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const title = css`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const tilesContainer = (theme: Theme) => css`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;

  @media (min-width: ${theme.breakpoints.tiny}) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;
